import { useState, useEffect } from 'react';
import css from './InvoiceOverview.module.css'; // Create a CSS module for styling

import * as invoiceServices from '../../../../services/invoiceService'; // Make sure this service exists
import InvoicesTable from './InvoicesTable'; // Create this table component
// import AddInvoice from './AddInvoice'; // Create this form component
import Overlay from '../../_common/elements/Overlay';
import AddInvoice from './AddInvoice';

function InvoiceOverview() {
    const [invoices, setInvoices] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let page;
        invoiceServices
            .getAll(page || 1)
            .then((result) => {
                setInvoices(() =>
                    result.data.sort((a, b) => b.invoiceId - a.invoiceId) || []
                );
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);

    const onAdd = (e, newData) => {
        e.preventDefault();

        invoiceServices
            .create(newData)
            .then((res) => {
                const updatedData = { ...newData, invoiceId: res.insertId };
                setInvoices((prev) => [updatedData, ...prev]);
                handleShowModal();
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const handleShowModal = () => {
        setShowModal((prev) => !prev);
    };

    return (
        <div className={css.main}>
            <InvoicesTable
                data={invoices}
                onAdd={onAdd}
                service={invoiceServices}
                showModal={handleShowModal}
            />
            {showModal && (
                <Overlay>
                    <AddInvoice onAdd={onAdd} onClose={handleShowModal} />
                </Overlay>
            )}
        </div>
    );
}

export default InvoiceOverview;
